export const tableOption = {
  border: true,
  stripe: true,
  menuAlign: 'center',
  align: 'center',
  editBtn: false,
  delBtn: false,
  addBtn: false,
  viewBtn: false,
  column: [
    {
      label: 'ID',
      prop: 'id',
      sortable: true
    },
    {
      label: '名称',
      prop: 'name',
      search: true,
      searchPlaceholder: '请输入'
    },
    {
      label: '分类',
      prop: 'tagName'
    },
    {
      label: '主题',
      prop: 'themeTagName'
    },
    {
      label: '创建时间',
      prop: 'insertedTime',
      sortable: true
    }
  ]
}
